/** Shown when `teacher_scenarios` is missing from `chat_modes` (migration not applied). */
export const TEACHER_SCENARIOS_SESSION_SETUP_ERROR =
  "Could not start a coaching session. Run this SQL on the HeyBodhi dev Supabase project (SQL Editor), then retry:\n\nINSERT INTO public.chat_modes (chat_mode)\nSELECT 'teacher_scenarios'\nWHERE NOT EXISTS (SELECT 1 FROM public.chat_modes WHERE chat_mode = 'teacher_scenarios');\n\nOr apply migration: supabase/migrations/20260614120000_add_teacher_scenarios_chat_mode.sql";

export function formatTeacherScenarioSessionError(cause: unknown): string {
  const detail = cause instanceof Error ? cause.message : String(cause);
  if (/chat_modes|foreign key|teacher_scenarios/i.test(detail)) {
    return TEACHER_SCENARIOS_SESSION_SETUP_ERROR;
  }
  if (/not authenticated|JWT/i.test(detail)) {
    return "Could not start a coaching session. Sign in to HeyBodhi, then try again.";
  }
  return `Could not start a coaching session. ${detail}`;
}
